module.exports = __webpack_public_path__ + "img/route.93e9de24.svg";